<div class="container">
  <div class="column">
    <h2>{{ labels.MEMBER_PASSWORD_HEADER }}</h2>
    <div class="error-message" *ngIf="formError">
      {{ formMessage }}
    </div>
    <div [formGroup]="memberPasswordForm">
      <mat-form-field>
        <mat-label>{{ labels.MEMBER_PASSWORD }}</mat-label>
        <input matInput formControlName="password" type="password" (input)="showErrorMessage()"/>
        <mat-icon
          matSuffix
          #tooltip="matTooltip"
          matTooltip="{{ labels.PASSWORD_TOOLTIP }}"
          matTooltipPosition="above"
          matTooltipShowDelay="{{ tooltipDelay.SHOW_DELAY }}"
          matTooltipHideDelay="{{ tooltipDelay.HIDE_DELAY }}"
        >contact_support
        </mat-icon>
        <mat-error>{{ labels.PASSWORD_TOOLTIP }}</mat-error>
      </mat-form-field>
    </div>
    <div [formGroup]="memberPasswordForm">
      <mat-form-field>
        <mat-label>{{ labels.MEMBER_CONFIRM_PASSWORD }}</mat-label>
        <input matInput formControlName="confirmPassword" type="password"/>
        <mat-error>{{
          labels.PASSWORD_TOOLTIP + labels.MEMBER_PASSWORD_MISMATCH
          }}</mat-error>
      </mat-form-field>
    </div>
    <div>
      {{ labels.MEMBER_PASSWORD_DESCRIPTION }}
    </div>
    <button
      mat-raised-button
      color="accent"
      [ngClass]="loading ? 'btn-primary spinner' : 'btn-primary'"
      (click)="updatePassword()"
      [disabled]="!validateForm() || loading"
    >
      {{ labels.MEMBER_SUBMIT }}
    </button>
  </div>
</div>
